import type {
  CreateStaffRequest,
  StaffDto,
  UpdateStaffRequest,
} from '@expeditor/shared';
import { apiClient } from './client';

export const adminStaffApi = {
  async list(): Promise<StaffDto[]> {
    const { data } = await apiClient.get<StaffDto[]>('/admin/staff');
    return data;
  },
  async create(dto: CreateStaffRequest): Promise<StaffDto> {
    const { data } = await apiClient.post<StaffDto>('/admin/staff', dto);
    return data;
  },
  async update(id: string, dto: UpdateStaffRequest): Promise<StaffDto> {
    const { data } = await apiClient.patch<StaffDto>(`/admin/staff/${id}`, dto);
    return data;
  },
  async setActive(id: string, isActive: boolean): Promise<StaffDto> {
    const { data } = await apiClient.patch<StaffDto>(`/admin/staff/${id}/active`, { isActive });
    return data;
  },
  async resetPassword(id: string, password: string): Promise<void> {
    await apiClient.post(`/admin/staff/${id}/reset-password`, { password });
  },
};
